module.exports = __webpack_public_path__ + "static/visage-37b36669e7980aaf65d8c4854f86b467.jpg";